const topics = [
  { label: '科幻大片', hot: '9.8万' },
  { label: '国产剧集', hot: '9.5万' },
  { label: '悬疑推理', hot: '8.7万' },
  { label: '动作冒险', hot: '8.2万' },
  { label: '喜剧搞笑', hot: '7.6万' },
  { label: '爱情文艺', hot: '7.1万' },
  { label: '战争历史', hot: '6.5万' },
  { label: '动漫番剧', hot: '6.0万' },
  { label: '纪录纪实', hot: '5.4万' },
  { label: '恐怖惊悚', hot: '4.8万' },
  { label: '经典老片', hot: '4.2万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">全网影迷都在关注的高清影视话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t) => (
            <div
              key={t.label}
              className="group px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors">{t.label}</span>
              <span className="ml-2 text-xs text-foreground-400">{t.hot}热度</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}